/**
 * Budget availability (FSD 2.2.5 "Budget Availability Report"; service contract
 * `GET .../budget/available`). Read-only, gated by `budget.check` as the server
 * route is.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_CYCLE_PERMISSIONS } from '@/modules/budget/cycles/permissions'

export const BUDGET_AVAILABILITY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/availability',
    name: 'budget-availability',
    component: () => import('@/modules/budget/availability/AvailabilityView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetAvailability',
      permission: BUDGET_CYCLE_PERMISSIONS.check,
    },
  },
]

export interface AvailabilityScope {
  companyId?: number | null
  fiscalYear?: number | null
  accountId?: number | null
  costCenterId?: number | null
  period?: number | null
}

export function availabilityRoute(scope: AvailabilityScope = {}): string {
  const params = new URLSearchParams()
  for (const key of ['companyId', 'fiscalYear', 'accountId', 'costCenterId', 'period'] as const) {
    const value = scope[key]
    if (value !== undefined && value !== null) params.set(key, String(value))
  }
  const query = params.toString()
  return query === '' ? '/budget/availability' : `/budget/availability?${query}`
}
